"use strict";

angular
  .module("loginModule")

  .controller(
    "LoginCtrl",
    function ($scope, $state, Auth, $rootScope, appConfig) {
      this.user = {
        username: "",
        password: "",
        two_fa_code: "",
        remember: false,
      };

      this.error = "";
      this.showTwoFaForm = false;

      this.twoFaLogin = function () {
        Auth.loginTwoFa(this.user).then(function (use) {
          $state.go(appConfig.theme.homeState);
        }, failedLogin.bind(this));
      };

      this.login = function () {
        this.error = "";

        Auth.login(this.user).then((response) => {
          if (response === "two_fa") {
            this.showTwoFaForm = true;
          } else {
            // Clear if there are some notification errors displayed
            // Notification.clearAll();
            if (
              response.permissions.includes("super-admin") ||
              response.permissions.includes("brand-site.enabled")
            ) {
              window.open(appConfig.theme.brandGuidelines, "_self");
            } else {
              $state.go(appConfig.theme.homeState);
            }
          }
        }, failedLogin.bind(this));
      };

      const failedLogin = (response) => {
        if (response.status !== 422) {
          this.error = response.data;
        } else {
          this.error = "";
        }
      };
    }
  );
